export var smaReview = {
  // Client and contributor review
  msgErrorSenderId: 'You cannot review this request',
  msgClaimNumber: 'Number',
  msgClaimName: 'Name',
  msgYourReview: 'Please write your comments below',
  msgSend: 'Submit',
  msgWarningEmptyReview: 'Are you sure you want to submit a rating without detailed feedback?',
  msgNoReviews: 'No reviews yet'
};